import React from 'react';
import { Sun, Moon, Monitor, Sparkles } from 'lucide-react';
import { useTheme } from './ThemeProvider';
import type { ThemePreference } from './types';
import { THEME_PREFERENCES } from './types';

const THEME_ICONS: Record<ThemePreference, React.ElementType> = {
  system: Monitor,
  light: Sun,
  dark: Moon,
  midnight: Sparkles,
};

export function ThemeSelector() {
  const { themePreference, setThemePreference, theme } = useTheme();

  // Get the icon for the current resolved theme (for the button)
  const CurrentIcon = THEME_ICONS[theme] || Moon;

  return (
    <div className="relative group">
      <button
        className="p-1.5 rounded-md hover:bg-accent transition-colors"
        title={`Theme: ${THEME_PREFERENCES.find(t => t.id === themePreference)?.name || 'System'}`}
      >
        <CurrentIcon className="w-4 h-4 text-muted-foreground" />
      </button>

      <div className="absolute right-0 top-full mt-1 w-36 bg-card border border-border rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
        <div className="p-1">
          {THEME_PREFERENCES.map(({ id, name }) => {
            const Icon = THEME_ICONS[id];
            const isSelected = themePreference === id;

            return (
              <button
                key={id}
                onClick={() => setThemePreference(id)}
                className={`w-full flex items-center gap-2 px-2 py-1.5 text-sm rounded-md transition-colors ${
                  isSelected
                    ? 'bg-accent text-foreground'
                    : 'text-muted-foreground hover:text-foreground hover:bg-accent/50'
                }`}
              >
                <Icon className="w-4 h-4" />
                {name}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
